import {Layout} from "antd";

export const { Header, Content, Footer, Sider } = Layout;